import { Link } from "react-router-dom";
import { topics } from "@/mocks/movies";

export default function TopicSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
        <div>
          <span className="inline-flex items-center gap-1.5 text-accent-600 text-xs font-semibold uppercase tracking-wider mb-1.5">
            <span className="w-4 h-0.5 bg-accent-500 rounded-full" />
            Collections
          </span>
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950">推荐专题集合</h2>
          <p className="mt-1 text-xs md:text-sm text-foreground-600">按主题精选的影视片单，帮你快速找到对味的内容</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to="/category/全部"
            className="group relative block h-44 md:h-52 rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src={topic.image}
              alt={`${topic.name} 专题`}
              title={`${topic.name} - 大师兄影视专题`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-4">
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-[11px] font-semibold mb-2">
                <i className="ri-bookmark-3-line" />
                {topic.count} 部作品
              </span>
              <h3 className="font-heading text-base md:text-lg font-bold text-background-50">{topic.name}</h3>
              <p className="mt-1 text-xs text-background-100/85 line-clamp-2">{topic.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}